<template>
  <div class="view-container">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1 class="text-center">Gestione Comunicazioni</h1>

    <div class="row justify-content-between mx-2 mt-5 mb-2 align-middle">
      <h4>Elenco comunicazioni</h4>
      <div class="text-right">
        <b-button
          v-if="!loading && tabIndex === 1"
          variant="primary"
          @click="onNewNotificaClick"
        >
          <font-awesome-icon
            icon="plus"
            class="mr-2"
          />Aggiungi comunicazione
        </b-button>
      </div>
    </div>

    <b-tabs
      v-model="tabIndex"
      @input="selectTab"
    >
      <b-tab
        title="Attive"
        active
      ></b-tab>
      <b-tab title="Bozze"></b-tab>
      <b-tab title="Storico"></b-tab>
    </b-tabs>

    <loading-spinner v-if="loading" />
    <template v-else>
      <b-alert
        v-if="!loading && !items.length"
        show
        variant="info"
        class="my-4"
      >
        <template v-if="tabIndex">
          Non ci sono comunicazioni nello storico.
        </template>
        <template v-else>
          Non ci sono precedenti comunicazioni in archivio.
          <!-- Premere il tasto "<a
            href="#"
            class="alert-link"
            @click="onNewNotificaClick"
          >Aggiungi notifica</a>" per inserirne una nuova. -->
        </template>
      </b-alert>

      <b-table
        v-if="items.length"
        striped
        bordered
        hover
        :fields="fields"
        :items="items"
        :responsive="true"
        :busy="false"
        @row-clicked="onRowClicked"
        :per-page="perPage"
        :currentPage="currentPage"
      >

        <template v-slot:head(icon)>
          <font-awesome-icon
            icon="search"
            size="lg"
            class="text-muted"
          />
        </template>
        <template v-slot:cell(icon)="data">
          <font-awesome-icon
            v-if="!data.item.dataPubblicazione"
            icon="pen"
            size="lg"
            class="text-primary"
          />
          <font-awesome-icon
            v-else
            icon="search"
            size="lg"
            class="text-info"
          />
        </template>

        <template v-slot:cell(utente)="data">
          <div class="text-nowrap">{{displayUtente(data.item[data.field.key])}}</div>
        </template>

        <!-- <template v-slot:head(attivo)="data">
          <div class="text-center">{{data.field.label}}</div>
        </template>
        <template v-slot:cell(attivo)="data">
          <div class="text-center">
            <font-awesome-icon
              v-if="data.item.attivo"
              icon="check"
              size="lg"
              class="text-success text-center"
            />
            <font-awesome-icon
              v-else
              icon="times"
              size="lg"
              class="text-danger text-center"
            />
          </div>
        </template> -->

        <template v-slot:head(tipoDest)="data">
          <div class="text-nowrap">{{data.field.label}}</div>
        </template>
        <template v-slot:cell(tipoDest)="data">
          {{destinatari[data.item[data.field.key]]}}
        </template>
        <template v-slot:cell(dataInizio)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>
        <template v-slot:cell(dataFine)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>
        <template v-slot:cell(dataPubblicazione)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>

        <template v-slot:head(download)>
          <font-awesome-icon
            icon="file-alt"
            size="lg"
            class="text-muted"
          />
        </template>

      </b-table>

      <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
        <div class="text-right">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </div>
        <div class="text-right">
          <b-form-group
            description="Per pagina"
            class="mb-0"
          >
            <b-form-select
              :options="pageOptions"
              v-model="perPage"
            />
          </b-form-group>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    LoadingSpinner
  },

  data () {
    return {
      fields: [
        'icon',
        { key: 'id', label: 'ID' },
        { key: 'testoBreve', label: 'Testo breve' },
        { key: 'tipoDest', label: 'Tipo Dest.' },
        { key: 'gruppo', label: 'Gruppo' },
        { key: 'utente', label: 'Rapporto Utenza' },
        { key: 'dataInizio', label: 'Inizio' },
        { key: 'dataFine', label: 'Fine' },
        { key: 'dataPubblicazione', label: 'Pubblicazione' },
        'download'
      ],
      loading: true,
      tabIndex: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20],
      destinatari: {
        T: 'Tutti',
        G: 'Gruppo',
        U: 'Utente',
        S: 'Utente Singolo'
      }
    }
  },

  async created () {
    await this.selectTab(0)
  },

  computed: {
    ...mapGetters('notifiche', ['items']),
    totalRows () { return this.items.length }
  },

  methods: {
    ...mapActions('notifiche', ['loadItems']),

    back () {
      this.$router.push({ name: 'admin-panel' })
    },
    displayUtente (valueUtente) {
      let retValue = valueUtente
      if (valueUtente) {
        retValue = valueUtente.length > 20 ? valueUtente.substring(0, 20) + '...' : valueUtente
      }
      return retValue
    },
    async selectTab (tab) {
      let params = {}
      switch (tab) {
        case 0:
          params = { attive: true, userAdmin: this.$store.state.auth.user.codiceUtente }
          // params = { attive: true, userAdmin: '' }
          break
        case 1:
          params = { bozze: true, userAdmin: this.$store.state.auth.user.codiceUtente }
          // params = { bozze: true, userAdmin: '' }
          break
        case 2:
          params = { storiche: true, userAdmin: this.$store.state.auth.user.codiceUtente }
          // params = { storiche: true, userAdmin: '' }
          break
      }
      await this.load(params)
      this.tabIndex = tab
    },

    async load (params = {}) {
      try {
        this.loading = true
        // console.log('async load (params = {}) {', params, this.$store.state.auth.user.codiceUtente)
        await this.loadItems(params)
        // console.log('notifiche caricate: ', this.items)
      } catch (err) {
        // console.log('Errore in load Lista notifiche')
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle notifiche esce comunque.
        this.$router.push({ name: 'admin-panel' })
      }
      this.loading = false
    },

    async onNewNotificaClick () {
      this.$router.push({ name: 'admin-notifica', params: { id: 'nuova', tabIndex: this.tabIndex, userAdmin: this.$store.state.auth.user.codiceUtente } })
    },

    onRowClicked (row) {
      this.$router.push({ name: 'admin-notifica', params: { id: row.id, tabIndex: this.tabIndex, userAdmin: this.$store.state.auth.user.codiceUtente } })
    },

    urlNotifica (id) {
      return `/api/notifiche/${id}/download`
    },

    isEditable (currentRow, idScope) {
      let retValue = false

      // console.log('idScope: ', idScope)
      if (idScope === 'search') {
        retValue = currentRow.editable !== null
      } else {
        retValue = currentRow.stato === 'P' && currentRow.editable !== 'NO'
      }
      // console.log('Riga corrente: ', currentRow.stato, currentRow.editable, retValue)
      return retValue
    },

    formatDateTime (dateStr) {
      // return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : ''
      return dateStr ? moment(dateStr).format('DD/MM/YYYY') : ''
    }

  }
}
</script>

<style lang="stylus" scoped>
.fixedLenght {
  width: 80px;
}
</style>
